/**
 * Created by VsCode.
 * @author Evan Chan
 * @date 2018/8/7
 */

// 应用具体配置
export const config = {
  httpHeaders: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  // Api对应的服务器及前缀, 请求分发
  apiPath: {
    //default: '/api',
    promotion: {
      development: '/promotion/api',
      waptest: '//test-promotion-platform-rest.myzebravip.com/api',
      wappreview: '//pre-promotion.myzebravip.com/api',
      wap: '//promotion.myzebravip.com/api'
    },
    default: {
      development: 'https://apigw.gegejia.com',
      test: 'https://apigwtest.gegejia.com',
      preview: 'https://apigwpre.gegejia.com',
      production: 'https://apigw.gegejia.com'
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js